import { Popover, Tooltip } from 'antd';
import { useDrag } from 'react-dnd';
import { DragItem, SeverityName } from 'store/ducks/InternalControls/types';
import * as Styled from './InternalControlsDND.styled';

export const DraggableItem: React.FC<{ item: DragItem }> = ({ item }) => {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: 'ITEM',
    item: {
      ...item,
      severity: item.severity ?? null
    },
    canDrag: () => !item.disabled,
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  }));

  const content = (
    <Styled.ItemBox
      ref={!item.disabled ? dragRef : undefined}
      isDragging={isDragging}
      disabled={item.disabled}
      severity={item.severity?.name as SeverityName | undefined}
    >
      {item.itemType === 'CONTROL' ? (
        <Popover
          content={<div>{item.description || 'No description available'}</div>}
        >
          <span style={{ cursor: 'pointer' }}>{item.text}</span>
        </Popover>
      ) : (
        item.text
      )}
    </Styled.ItemBox>
  );

  return item.disabled ? (
    <Tooltip
      title={
        <Styled.TooltipTitle>
          Disabled due to a previous Risk/Control type change.
        </Styled.TooltipTitle>
      }
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};
